// EditDoctor Component for updating doctor data

// Import Modules 
import React, { useState, useEffect } from "react"; 
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios"; 
import MandalInfoForm from "../Forms/MandaliInfoForm"; 
import CONFIG from "../../config";
import "../../Styles/doctorlist.css"
import { usePatient } from "../../context/PatientContext";

const EditDoctor = () => {
  let { id } = useParams();
  const [doctorInfo, setDoctorInfo] = useState(null);
  const [submissionState, setSubmissionState] = useState(null);
  const baseURL = CONFIG.BASE_URL;
  let navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const userData = usePatient();

  useEffect(() => {
    console.log(userData.doctorInfo);
    if (!id) {
      console.error("Doctor ID is undefined. Cannot fetch data.");
      return;
    }
//    axios.get(`${baseURL}/doctors/${id}`)
axios.get(`${baseURL}/doctors/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`,        // 🔐 JWT Token
    doctorId: userData.doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
    clinicId: userData.doctorInfo.CLINIC_ID,
    roleid: userData.doctorInfo.MANDALI_ROLE
  }
})
.then((res) => {
  setDoctorInfo(res.data);
})
.catch((err) => {
  if (err.response && err.response.status === 404) {
    alert("Doctor not found! Redirecting...");  
    navigate("/doctors");  // Redirect to the doctor list
  } else {
    console.error('Error fetching doctor details:', err);
  }
});
}, [id]);

  const onSubmitHandler = (updatedDoctorData) => { 
    setDoctorInfo(updatedDoctorData);
//    setSubmissionState({ submitted: true });
updateDoctorData(updatedDoctorData);


};

  // useEffect(() => {
  //   if (submissionState?.submitted) {
  //     updateDoctorData(doctorInfo);
  //   }
  // }, [submissionState]);

  const updateDoctorData = async (doctorInfo) => {
    try {
//      const response = await axios.put(`${baseURL}/doctors/update/${doctorInfo.MANDALI_ID}`, doctorInfo);
const response = await axios.put(`${baseURL}/doctors/update/${doctorInfo.MANDALI_ID}`, doctorInfo, {
  headers: {
    Authorization: `Bearer ${token}`,        // 🔐 JWT Token
    doctorId: userData.doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
    clinicId: userData.doctorInfo.CLINIC_ID,
    roleId: userData.doctorInfo.MANDALI_ROLE
  }
});

      console.log('Update response:', response.data);
      alert("Doctor updated successfully");
      if (userData.doctorInfo.MANDALI_ROLE === 1) {
        navigate("/doctors");
      }
      else {
        navigate("/getmandaliinfo");

      }
    } catch (error) {
      console.error('Error updating doctor:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div>
      {doctorInfo && (
        <MandalInfoForm 
          initialValues={doctorInfo} 
          onSubmit={onSubmitHandler} 
          enableReinitialize={true}
        > 
          Update Doctor
        </MandalInfoForm> 
      )}
    </div>
  );
};

export default EditDoctor;
